import React, { useState, useEffect, useCallback } from "react";
import { producaov2 } from "../../../services/apis";
import { Dropdown, Table } from "semantic-ui-react";
import { ActionButtons, Container } from "./styles";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { RiDeleteBinLine } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { AlunoSearchInput } from "../../../components/Admin/AlunoSearchInput";

export const MBAListByUser = () => {
  const [mbas, setMbas] = useState([]);
  const [selectedAluno, setSelectedAluno] = useState(null);

  useEffect(() => {
    if (!selectedAluno) return;

    producaov2
      .get(`/admin/mba/list-from-aluno/${selectedAluno}`)
      .then((response) => setMbas(response.data));
  }, [selectedAluno]);

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>
      <AdminMenu />
      <Container>
        <h1>Lista MBAs</h1>

        <AlunoSearchInput
          handleChange={(evt) => {
            setSelectedAluno(evt.id);
          }}
        />

        <Table>
          <Table.Header>
            <Table.HeaderCell>ID</Table.HeaderCell>
            <Table.HeaderCell>ID Curso</Table.HeaderCell>
            <Table.HeaderCell>ID Combo</Table.HeaderCell>
            <Table.HeaderCell>Descrição</Table.HeaderCell>
            <Table.HeaderCell>Ativo</Table.HeaderCell>
            <Table.HeaderCell>Ações</Table.HeaderCell>
          </Table.Header>

          <Table.Body>
            {mbas &&
              mbas.map((mba) => (
                <Table.Row key={mba.id}>
                  <Table.Cell>{mba.id}</Table.Cell>
                  <Table.Cell>{mba.id_curso}</Table.Cell>
                  <Table.Cell>{mba.id_combo}</Table.Cell>
                  <Table.Cell>{mba.descricao}</Table.Cell>
                  <Table.Cell>{mba.is_active ? "S" : "N"}</Table.Cell>
                  <Table.Cell>
                    <ActionButtons>
                      <a href={`/admin/mba/list/${mba.id}`}>
                        <FaRegEdit size={16} color="var(--color-primary)" />
                      </a>
                    </ActionButtons>
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
      </Container>
    </div>
  );
};
